import React from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { useAuth } from "../../providers/AuthProvider";

/**
 * Blocks routes (e.g. POS) until business profile onboarding is 100% complete.
 * Dashboard and onboarding paths stay accessible via sibling routes.
 */
export function RequireCompleteBusinessProfile() {
  const { user, needsProfileCompletion, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return null;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;

  if (user.role === "super_admin") return <Outlet />;

  if (needsProfileCompletion) {
    return <Navigate to="/onboarding/business-profile" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
